import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube } from "lucide-react";

const COLS = [
  { title: "Shop", links: [["Shop All", "/shop"], ["Belt Bags", "/shop/belt-bags"], ["Crossbody Bags", "/shop/crossbody-bags"], ["New Arrivals", "/shop/new-arrivals"], ["Coming Soon", "/coming-soon"]] },
  { title: "Help", links: [["Track Order", "/track-order"], ["Shipping & Returns", "/contact#faq"], ["Contact Us", "/contact"], ["Account", "/account"]] },
  { title: "MARKHOR", links: [["Our Story", "/our-story"], ["The Emblem", "/#emblem"]] },
];

export const Footer = () => (
  <footer className="bg-night text-[#C9C9CC]" data-testid="site-footer">
    <div className="mx-auto max-w-[1600px] px-5 pb-10 pt-20 md:px-10">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-4">
            <img src="/img/emblem.png" alt="MARKHOR emblem" className="h-14 w-14" />
            <span className="font-display text-3xl font-semibold uppercase tracking-[0.34em] text-ivory">Markhor</span>
          </div>
          <p className="mt-6 max-w-sm text-sm leading-relaxed">Move freely. Live boldly. Premium everyday bags designed around the way you move.</p>
          <p className="mt-6 text-sm">Email support: <a href="mailto:support@shopmarkhor.com" className="link-line text-[#E4E4E6]" data-testid="footer-support-email">support@shopmarkhor.com</a></p>
        </div>
        {COLS.map((c) => (
          <div key={c.title} className="md:col-span-2">
            <p className="label-mono !text-[#A1A1A6]">{c.title}</p>
            <ul className="mt-5 space-y-3 text-sm">
              {c.links.map(([l, to]) => (
                <li key={l}><Link to={to} className="link-line text-[#E4E4E6]" data-testid={`footer-link-${l.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{l}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-20 overflow-hidden">
        <p className="select-none whitespace-nowrap text-center font-display text-[15vw] font-light uppercase leading-[0.9] tracking-[-0.02em] text-ivory/[0.08] 2xl:text-[250px]">Markhor</p>
      </div>
      <div className="mt-8 flex flex-col gap-4 border-t border-white/10 pt-6 text-xs md:flex-row md:items-center md:justify-between">
        <p>© 2026 MARKHOR. All rights reserved. · Secure checkout powered by Shopify</p>
        <div className="flex gap-4">
          {[Instagram, Facebook, Youtube].map((I, i) => (
            <a key={i} href="#" aria-label="Social link" data-testid={`footer-social-${i}`} className="text-[#E4E4E6] transition-opacity hover:opacity-70"><I className="h-4 w-4" /></a>
          ))}
        </div>
      </div>
    </div>
  </footer>
);
